import React from 'react'

interface CardProps {
  children: React.ReactNode
  className?: string
  padding?: 'none' | 'sm' | 'md' | 'lg'
  shadow?: 'none' | 'sm' | 'md' | 'lg'
  hover?: boolean
  style?: React.CSSProperties
  'data-component-name'?: string
}

export function Card({
  children,
  className = '',
  padding = 'md',
  shadow = 'sm',
  hover = false,
  style,
  'data-component-name': dataComponentName = 'Card',
}: CardProps) {
  const paddingStyles = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  }

  const shadowStyles = {
    none: '',
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
  }

  const hoverStyle = hover ? 'hover:shadow-xl transition-shadow duration-300' : ''

  return (
    <div
      data-component-name={dataComponentName}
      style={style}
      className={`
        bg-white 
        rounded-xl 
        ${paddingStyles[padding]} 
        ${shadowStyles[shadow]} 
        ${hoverStyle}
        ${className}
      `}
    >
      {children}
    </div>
  )
}
